import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { ContactInfo } from './OrderTypes';

interface OrderSuccessPanelProps {
  orderId: string;
  contactInfo: ContactInfo;
  cartTotal: number;
  getWhatsAppLink: () => string;
  onResetOrderFlow: () => void;
}

const OrderSuccessPanel: React.FC<OrderSuccessPanelProps> = ({ orderId, contactInfo, cartTotal, getWhatsAppLink, onResetOrderFlow }) => (
  <div className="success-card-wrapper bg-white shadow rounded-4 p-3 p-sm-5 text-center border border-light mx-auto my-5" style={{ maxWidth: '650px' }}>
    <div className="success-icon-badge mb-4">
      <i className="fas fa-check-circle" style={{ fontSize: '72px', color: '#00c853' }}></i>
    </div>
    <h3 className="fw-bold text-dark mb-2">Order Paid & Placed!</h3>
    <p className="text-muted mb-4">
      Your order payment was verified successfully. Reference ID:
    </p>
    <div className="order-id-display py-2 px-3 bg-light border rounded-3 fw-bold text-primary d-inline-block font-monospace mb-4" style={{ fontSize: '18px' }}>
      {orderId}
    </div>

    <div className="text-start bg-light border border-light rounded-3 p-4 mb-4">
      <h5 className="fw-bold text-dark mb-3">Order Details Summary</h5>
      <Row className="mb-2">
        <Col xs={5} className="text-muted font-weight-500">Customer Name:</Col>
        <Col xs={7} className="fw-semibold">{contactInfo.name}</Col>
      </Row>
      <Row className="mb-2">
        <Col xs={5} className="text-muted font-weight-500">Phone Number:</Col>
        <Col xs={7} className="fw-semibold">{contactInfo.phone}</Col>
      </Row>
      <Row className="mb-2">
        <Col xs={5} className="text-muted font-weight-500">Delivery Type:</Col>
        <Col xs={7} className="fw-semibold text-capitalize">{contactInfo.deliveryType === 'pickup' ? 'Store Pickup' : 'Home Delivery'}</Col>
      </Row>
      <hr className="my-3" style={{ borderStyle: 'dashed' }} />
      <Row className="mb-2">
        <Col xs={5} className="text-muted font-weight-500">Total Price Paid:</Col>
        <Col xs={7} className="fw-bold text-success" style={{ fontSize: '18px' }}>₹{cartTotal.toLocaleString('en-IN')}</Col>
      </Row>
    </div>

    <div className="alert alert-warning border-0 rounded-3 mb-4 text-start d-flex gap-3 align-items-start" style={{ backgroundColor: '#fff8e1' }}>
      <i className="fas fa-info-circle text-warning mt-1" style={{ fontSize: '18px' }}></i>
      <div style={{ fontSize: '13px', color: '#6d4c41', lineHeight: '1.5' }}>
        <strong>Need updates?</strong> Click the button below to send your receipt parameters and details to our WhatsApp team for priority order processing.
      </div>
    </div>

    <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
      <a
        href={getWhatsAppLink()}
        target="_blank"
        rel="noreferrer"
        className="btn btn-success py-3 px-4 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
        style={{ borderRadius: '10px', fontSize: '15px' }}
      >
        <i className="fab fa-whatsapp" style={{ fontSize: '20px' }}></i> Send Receipt to WhatsApp
      </a>
      <Button
        variant="outline-secondary"
        className="py-3 px-4 fw-semibold"
        style={{ borderRadius: '10px', fontSize: '15px' }}
        onClick={onResetOrderFlow}
      >
        Configure Another Item
      </Button>
    </div>
  </div>
);

export default OrderSuccessPanel;
